var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"mapContainer",staticClass:"yandex-map-container",class:{
    'yandex-map-container--static': !_vm.interactive,
    'yandex-map-container--fill': _vm.fill,
  },style:(_vm.containerStyle)})}
var staticRenderFns = []

export { render, staticRenderFns }